import { render, staticRenderFns } from "./ConsolidatedDashboard.vue?vue&type=template&id=13ad639c"
import script from "./ConsolidatedDashboard.vue?vue&type=script&lang=js"
export * from "./ConsolidatedDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports